if(typeof mainSliderLoop === 'undefined')
    mainSliderLoop = false;

var SITE_CONSTANT = {
    today: new Date(),
    yearFromBack: 100,
    yearToFuture: 0,
    dayToFuture: 0,
    futureLimit: 7,
    minPasswordLength: 6
};
var SITE_CONFIG = {
    general: {
        responsive: '(max-width: 960px)', /* kaç px de responsive geçecegi */
        regex: {
            typ1: /[^a-zA-ZiiIgüsöçIGÜSÖÇ\s]+/, /* sadece harf */
            typ2: /[^0-9\s]+/, /* sadece rakam */
            typ3: /[^a-zA-ZiiI0-9güsöçIGÜSÖÇ\s]+/ /* harf rakam karisik */
        },
        preloader: '',
        clipboard: '<input type="text" id="clipboard" value="{{VAL}}" tabindex="-1" aria-hidden="true" readonly />',
        googleMapAPI: '//maps.googleapis.com/maps/api/js?libraries=places,geometry&v=weekly&key=',
        url: '',
        share: {
            fb: 'https://www.facebook.com/sharer/sharer.php?u={{URL}}',
            tw: 'https://x.com/intent/tweet?text={{TEXT}}&url={{URL}}',
            tg: 'https://t.me/share/url?text={{TEXT}} {{URL}}',
            wp: 'https://api.whatsapp.com/send?text={{TEXT}} {{URL}}'
        }
    },
    plugin: {
        
        /* 
            swiper config
        */
        swiper: {
            defaultOpt: {
                videoStretching: 'responsive'
            },
            main: {
                slidesPerView: 'auto',
                pagination: {
                    el: '.swiper-pagination',
                    clickable: true,
                    dynamicBullets: true
                },
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                }
            },
            compare: {
                slidesPerView: 'auto',
                pagination: {
                    el: '.swiper-pagination',
                    clickable: true,
                    dynamicBullets: true
                },
                navigation: {
                    nextEl: '.swiper-compare-next',
                    prevEl: '.swiper-compare-prev',
                }
            },
            innerSlider: {
                slidesPerView: 1,
                effect: isMobile ? 'slide' : 'fade',
                pagination: {
                    el: '.swiper-pagination-inner',
                    clickable: true
                },
                navigation: {
                    nextEl: '.swiper-button-next-inner',
                    prevEl: '.swiper-button-prev-inner',
                }
            },
            badgeSlider: {
                slidesPerView: 1,
                pagination: {
                    el: '.swiper-pagination',
                    clickable: true,
                    dynamicBullets: true
                },
                navigation: {
                    nextEl: '.swiper-multiple-next',
                    prevEl: '.swiper-multiple-prev',
                }
            },
            categories: {
                slidesPerView: 'auto',
                freeMode: true,
                scrollbar: {
                    el: '.swiper-scrollbar',
                    hide: false,
                    draggable: true,
                    dragSize: 300
                },
                pagination: {
                    el: '.swiper-pagination-inner',
                    clickable: true
                },
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                }
            },
            quickLinks: {
                slidesPerView: 'auto',
                freeMode: true,
                scrollbar: {
                    el: '.swiper-scrollbar',
                    hide: false,
                    draggable: true,
                    dragSize: 300
                },
                pagination: {
                    el: '.swiper-pagination-inner',
                    clickable: true
                },
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                }
            },
            singleItem: {
                slidesPerView: 1,
                pagination: {
                    el: '.swiper-pagination',
                    clickable: true,
                    dynamicBullets: true
                },
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                }
            },
            pdpGallery: {
                slidesPerView: 1,
                pagination: {
                    el: '.swiper-pagination',
                    clickable: true,
                    dynamicBullets: true
                },
                navigation: {
                    nextEl: '.swiper-controls .swiper-button-next',
                    prevEl: '.swiper-controls .swiper-button-prev',
                }
            },
            pdpGalleryModal: {
                slidesPerView: 1,
                pagination: {
                    el: '.swiper-controls .swiper-pagination',
                    clickable: true,
                    dynamicBullets: true
                },
                navigation: {
                    nextEl: '.swiper-controls .swiper-button-next',
                    prevEl: '.swiper-controls .swiper-button-prev',
                }
            },
            singleItemAutoLoop: {
                slidesPerView: 1,
                loop: true,
                effect: 'slide',
                pagination: {
                    el: '.swiper-pagination',
                    clickable: true,
                    dynamicBullets: true
                },
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                },
                autoplay: {
                    delay: 4000,
                    disableOnInteraction: false
                }
            },
            mainSlider: {
                slidesPerView: 1,
                loop: mainSliderLoop,
                allowTouchMove: false,
                simulateTouch: false,
                pagination: {
                    el: '.swiper-pagination',
                    clickable: true,
                    dynamicBullets: false
                },
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                },
                autoplay: {
                    delay: 7000,
                    disableOnInteraction: false,
                    stopOnLastSlide: false
                }
            },
            techSlider: {
                slidesPerView: 1,
                loop: true,  
                rewind: true,
                slideCounter: true,
                pagination: {
                    el: '.swiper-pagination',
                    clickable: true,
                    dynamicBullets: true
                },
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                },
                autoplay: {
                    delay: 7000,
                    disableOnInteraction: false,
                    stopOnLastSlide: false
                }
            },
            ftcSlider: {
                slidesPerView: isMobile ? 'auto' : 3,
                freeMode: true,
                scrollbar: {
                    el: '.swiper-scrollbar',
                    hide: false,
                    draggable: true,
                    dragSize: 300
                },
                pagination: {
                    el: '.swiper-pagination-inner',
                    clickable: true
                },
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                },
                autoplay: {
                    delay: 7000,
                    disableOnInteraction: false,
                    stopOnLastSlide: false
                }
            },
            rvwUserMedias: {
                slidesPerView: 'auto',
                loop: true,  
                rewind: true,
                pagination: {
                    el: '.swiper-pagination',
                    clickable: true,
                    dynamicBullets: true
                },
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                }
            }
        },
        pikaday: {
            defaults: {
                i18n: {
                    previousMonth : 'Önceki Ay',
                    nextMonth     : 'Sonraki Ay',
                    months        : ['Ocak','Şubat','Mart','Nisan','Mayıs','Haziran','Temmuz','Ağustos','Eylül','Ekim','Kasım','Aralık'],
                    weekdays      : ['Pazar','Pazartesi','Salı','Çarşamba','Perşembe','Cuma','Cumartesi'],
                    weekdaysShort : ['Paz','Pzt','Sal','Çar','Per','Cum','Cmt']
                },
                firstDay: 1,
                formatStrict: true,
                format: 'DD/MM/YYYY',
                toString: function(date, format) {
                    return ('0' + date.getDate()).slice(-2) + '/' + ('0' + (date.getMonth() + 1)).slice(-2) + '/' + date.getFullYear();
                },
                parse: function(dateString, format) {
                    var parts = dateString.split('/');
                    // new Date(Year, Month, Day)
                    return new Date(parseInt(parts[2], 10), parseInt(parts[1], 10) - 1, parseInt(parts[0], 10));
                }
            },
            sets: {
                birthday: {
                    maxDate: new Date(),
                    yearRange: [SITE_CONSTANT.today.getFullYear() - SITE_CONSTANT.yearFromBack, SITE_CONSTANT.today.getFullYear()]
                },
                futureDate: {
                    minDate: new Date(Date.now() + SITE_CONSTANT.dayToFuture * 24 * 60 * 60 * 1000),
                    maxDate: new Date(Date.now() + SITE_CONSTANT.futureLimit * 24 * 60 * 60 * 1000),
                    yearRange: [SITE_CONSTANT.today.getFullYear()]
                }
            }
        },
        cleave: {
            phone1: {
                delimiter: '',
                blocks: [2, 9],
                prefix: '05',
                numericOnly: true,
                noImmediatePrefix: false,
                delimiterLazyShow: true
            },
            phone2: {
                delimiter: '',
                blocks: [3, 10],
                prefix: '+90',
                numericOnly: true,
                noImmediatePrefix: false,
                delimiterLazyShow: true
            },
            phone3: {
                delimiter: '',
                blocks: [1, 9],
                prefix: '5',
                numericOnly: true,
                noImmediatePrefix: false,
                delimiterLazyShow: true
            },
            phone4: {
                delimiter: '',
                blocks: [2, 9],
                prefix: '',
                numericOnly: true,
                noImmediatePrefix: false,
                delimiterLazyShow: true
            },
            otp: {
                blocks: [6],
                numericOnly: true
            },
            amount: {
                numeral: true,
                numeralPositiveOnly: true,
                numeralDecimalMark: ',',
                delimiter: '.'
            },
            birthday: {
                date: true,
                datePattern: ['d', 'm', 'Y'],
                dateMin: (SITE_CONSTANT.today.getFullYear() - SITE_CONSTANT.yearFromBack)+'-01-01',
                dateMax: SITE_CONSTANT.today.getFullYear()+'-'+(SITE_CONSTANT.today.getMonth()+1)+'-'+SITE_CONSTANT.today.getDate()
            },
            futureDate: {
                date: true,
                datePattern: ['d', 'm', 'Y'],
                dateMin: SITE_CONSTANT.today.getFullYear()+'-'+(SITE_CONSTANT.today.getMonth()+1)+'-'+(SITE_CONSTANT.today.getDate() + SITE_CONSTANT.dayToFuture),
                dateMax: (SITE_CONSTANT.today.getFullYear() + SITE_CONSTANT.yearToFuture)+'-'+(SITE_CONSTANT.today.getMonth()+1)+'-'+(SITE_CONSTANT.today.getDate() + SITE_CONSTANT.futureLimit)
            },
        },
        countdown: {
            hour: '<span class="digit">{hnn}</span>{sep}<span class="digit">{mnn}</span>{sep}<span class="digit">{snn}</span>',
            day: '<span class="digit day">{dnn}<i>{{DAY}}</i></span><span class="digit">{hnn}</span>{sep}<span class="digit">{mnn}</span>{sep}<span class="digit">{snn}</span>'
        }
    },
    animations: {
        mobile:{
            headerTransform:{
                trigger: {
                    trigger: '#wrapper', 
                    start: 50, 
                    toggleClass: false,
                    onEnter: function(){
                        $('body').toggleClass('header-opaque');
                    },
                    onLeaveBack: function(){
                        $('body').toggleClass('header-opaque');
                    }
                }
            },
            pageCover: {
                trigger: {
                    start: 'top top+=50'
                },
                tween: {
                    y: 100
                }
            },
            MSPrd: {
                trigger: {
                    trigger: '#main-slider',
                    start: 'top top'
                },
                tween: {
                    y: 100
                }
            },
            inView:{
                trigger: {
                    toggleClass: false,
                    start: '40% 100%',
                    onEnter: function(ths){
                        $(ths.trigger).addClass('in-view');
                    }
                }
            },
            PDPGallery: {
                trigger: {
                    start: 'top top+=95'
                },
                tween: {
                    y: 150,
                    opacity: 0,
                    scale: .9
                }
            },
            PDPBreadcrump:{
                trigger: {
                    start: 'top top+=50'
                },
                tween: {
                    opacity: 0
                }
            },
            PDPPurchase:{
                trigger: {
                    start: 'bottom top',
                    toggleClass: false,
                    onEnter: function(ths){
                        var tH = $(ths.trigger).innerHeight();
                        $(ths.trigger).css({'min-height': tH});
                        $('body').addClass('pdp-purchase-ready');
                    },
                    onLeaveBack: function(){
                        $('.pdp-purchase .btn-switch.activated').trigger('click');
                        $('body').removeClass('pdp-purchase-ready');
                    }
                }
            },
            gnrSticky:{
                trigger: {
                    start: 'bottom top',
                    toggleClass: false,
                    onEnter: function(ths){
                        var tH = $(ths.trigger).innerHeight();
                        $(ths.trigger).css({'min-height': tH});
                        $('body').addClass('gnr-sticky-ready');
                    },
                    onLeaveBack: function(){
                        $('body').removeClass('gnr-sticky-ready');
                    }
                }
            },
            compareHeader:{
                trigger: {
                    trigger: '.compare-holder',
                    start: 'top top', 
                    toggleClass: false,
                    onEnter: function(ths){
                        $(ths.trigger).toggleClass('title-block');
                    },
                    onLeaveBack: function(ths){
                        $(ths.trigger).toggleClass('title-block');
                    }
                }
            }
        },
        desktop:{
            headerTransform:{
                trigger: {
                    trigger: '#wrapper', 
                    start: 50, 
                    toggleClass: false,
                    onEnter: function(){
                        $('body').toggleClass('header-opaque');
                    },
                    onLeaveBack: function(){
                        $('body').toggleClass('header-opaque');
                    }
                }
            },
            pageCover: {
                trigger: {
                    start: 'top top+=50'
                },
                tween: {
                    y: 100
                }
            },
            MSPrd: {
                trigger: {
                    trigger: '#main-slider',
                    start: 'top top'
                },
                tween: {
                    y: 0
                }
            },
            inView:{
                trigger: {
                    toggleClass: false,
                    start: '40% 100%',
                    onEnter: function(ths){
                        $(ths.trigger).addClass('in-view');
                    }
                }
            },
            compareHeader:{
                trigger: {
                    trigger: '.compare-holder',
                    start: 'top top', 
                    toggleClass: false,
                    onEnter: function(ths){
                        $(ths.trigger).toggleClass('title-block');
                    },
                    onLeaveBack: function(ths){
                        $(ths.trigger).toggleClass('title-block');
                    }
                }
            },
            PDPPurchase:{
                trigger: {
                    start: 'bottom top',
                    toggleClass: false,
                    onEnter: function(ths){
                        var tH = $(ths.trigger).innerHeight();
                        $(ths.trigger).css({'min-height': tH});
                        $('body').addClass('pdp-purchase-ready');
                    },
                    onLeaveBack: function(){
                        $('.pdp-purchase .btn-switch.activated').trigger('click');
                        $('body').removeClass('pdp-purchase-ready');
                    }
                }
            },
            gnrSticky:{
                trigger: {
                    start: 'bottom top',
                    toggleClass: false,
                    onEnter: function(ths){
                        var tH = $(ths.trigger).innerHeight();
                        $(ths.trigger).css({'min-height': tH});
                        $('body').addClass('gnr-sticky-ready');
                    },
                    onLeaveBack: function(){
                        $('body').removeClass('gnr-sticky-ready');
                    }
                }
            },
        }
    }
};
